export default {
  updateUserData: {
    updateUserInfo: 'updateUserData.updateUserInfo',
    passwordUpdate: 'updateUserData.passwordUpdate',
    cardAdded: 'updateUserData.cardAdded',
    cardDelete: 'updateUserData.cardDelete',
  },
};
